import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Link } from '@paypalcorp/pp-react-links';

import getLocaleMessages from '../../../utils/localesMessages';
import { renderSwitchComponent } from '../../switchPanels/SwitchPanel';
import ExtraVariablesTextArea from '../../fields/ExtraVariablesTextArea';

const { advanced: { variables = {} } = {} } = getLocaleMessages(
  'buttonsV3/advancedVariables'
);

const renderExtraVariablesAreaField = (props) => {
  return <ExtraVariablesTextArea {...props} />;
};

const AdvancedVariables = ({ extraVariablesView, noAdvancedVariables }) => {
  const isChecked = noAdvancedVariables === 'no';

  return (
    <>
      <Field
        id="advanced-variables-switch"
        name="noAdvancedVariables"
        title={variables.switch.title}
        subTitle={variables.switch.subtitle}
        component={renderSwitchComponent}
        isChecked={isChecked}
        reversed={true}
      />

      {isChecked && (
        <div className="advanced-variables">
          <Link
            className="dev-doc-link"
            href="https://developer.paypal.com/docs/paypal-payments-standard/integration-guide/Appx-websitestandard-htmlvariables"
            target="_blank"
            data-testid="dev-doc"
          >
            {variables.devDoc}
          </Link>

          <Field
            id="extraVariablesView"
            name="extraVariablesView"
            type="text"
            label={variables.placeholder}
            value={extraVariablesView}
            component={renderExtraVariablesAreaField}
          />
        </div>
      )}
    </>
  );
};

AdvancedVariables.propTypes = {
  extraVariablesView: PropTypes.string,
  noAdvancedVariables: PropTypes.string,
};

export default AdvancedVariables;
